import { OrgRoleType } from './api';

export * from './auth';
export { color } from './color';

export const roleLabel: Record<string, string> = {
    [OrgRoleType.admin]: 'Admin',
    [OrgRoleType.member]: 'Member',
};

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value != null;
}
